module.exports = __webpack_public_path__ + "static/media/leitold-logo-trans.aa3e6f4a.png";